import { render, staticRenderFns } from "./Broadband.vue?vue&type=template&id=635d32ea&scoped=true&"
import script from "./Broadband.vue?vue&type=script&lang=js&"
export * from "./Broadband.vue?vue&type=script&lang=js&"
import style0 from "./Broadband.vue?vue&type=style&index=0&id=635d32ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635d32ea",
  null
  
)

export default component.exports